import { ToastStructure } from "../store";
import { TOAST } from "../actions-constants/toast.constants";

const initialToast:ToastStructure = new ToastStructure

export function toastReducer(toast:ToastStructure = initialToast,action):ToastStructure {
    switch (action.type) {
        case TOAST.SHOW_TOAST:
            return {...toast, message: action.message, show:action.show, onClose: action.onClose}
        case TOAST.HIDE_TOAST:
            return {...toast, show:action.show}
        default:
            return toast
    }
}